import React, { useRef, useState, useEffect } from "react";
import * as echarts from "echarts";
const ImageRatingGraph = ({ option }) => {
  const refImageRating = useRef();
  const [render, setrender] = useState(false);
  const formatTitle = (title) => {
    return (title + " ").replace(/(\S(.{0,60}\S)?)\s+/g, "$1\n").trim();
  };
  useEffect(() => {
    let chartDom = refImageRating.current;
    let myChart = echarts.init(chartDom);
    let chartTitle =
      option.title.length > 60 ? formatTitle(option.title) : option.title;
    let configuration = {
      title: {
        text: chartTitle,
        subtext: option.subtitle,
        left: "center",
        subtextStyle: {
          fontWeight: "bolder",
        },
      },
      tooltip: {},
      xAxis: {
        max: option.strictLimit ? option.limit : 10,
        splitLine: { show: false },
        offset: 0,
        axisLine: {
          lineStyle: {
            color: "#999",
          },
        },
        axisLabel: {
          margin: 10,
        },
      },
      yAxis: {
        type: "category",
        data: option.labels,
        animationDuration: 300,
        animationDurationUpdate: 300,
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          margin: 10,
          color: "#999",
          fontSize: 16,
        },
      },
      grid: {
        top: "center",
        height: option.data.length * 50,
        left: 70,
        right: 100,
      },
      series: [
        {
          realtimeSort: true,
          type: "pictorialBar",
          symbol: option.symbol,
          symbolRepeat: "fixed",
          symbolMargin: "10%",
          symbolClip: true,
          symbolSize: 37,
          symbolBoundingData: option.strictLimit ? option.limit : 10,
          data: option.data,
          hoverAnimation: true,
          animationDelay: function (dataIndex, params) {
            return params.index * 30;
          },
          markLine: {
            symbol: "none",
            label: {
              show: false,
            },
            lineStyle: {
              color: "green",
              type: "dotted",
              opacity: 0.2,
              width: 2,
            },
            data: [
              {
                type: "max",
              },
            ],
          },
          z: 10,
        },
        {
          realtimeSort: true,
          symbol: option.symbolLimit,
          type: "pictorialBar",
          itemStyle: {
            normal: {
              opacity: 0.9,
            },
          },
          label: {
            show: true,
            formatter: option.formaterLegent,
            position: "right",
            offset: [10, 0],
            color: "green",
            fontSize: 18,
          },
          symbolBoundingData: option.strictLimit ? option.limit : 10,
          animationDuration: 0,
          symbolRepeat: "fixed",
          symbolMargin: "10%",
          symbolSize: 37,
          data: option.data,
          z: 5,
        },
      ],
      animationEasing: "elasticOut",
      animationDelayUpdate: function (idx) {
        return idx * 5;
      },
    };

    configuration && myChart.setOption(configuration);
    setrender(!render);
  }, [option]);

  return (
    <>
      <div
        ref={refImageRating}
        style={{
          width: option.width ? option.width : "600px",
          height: option.height ? option.height : "400px",
          margin: "auto",
        }}
      ></div>
    </>
  );
};

export default ImageRatingGraph;
